module.exports = "../study/imgs/maps/Kanagawa/GWQ8/Climate/TemperatureMin/Kanagawa_TemperatureMin_MRI_RCP85_End.png";